import React from "react";
import WhatsNewButton from "./components/whats-new-button";
import QuickLinksGrid from "./components/quick-links-grid";

export default function Home() {
  return (
    <div className="w-full">
      <WhatsNewButton />
      <QuickLinksGrid />
    </div>
  );
}
